import { Text, View } from '@react-pdf/renderer';
import logo from '@ui/assets/images/MWS/MATTHEW_WARREN_SPRING_RGB_PRIMARY_LOGO_AW.png';
import { EnvConfig } from '@ui/config/env';

import { usePDFContext } from '../PDFProvider';
import { EmployeeInformation } from './components/EmployeeInformation';
import { Header } from './components/Header';
import { Logo } from './components/Logo';
import { List, ListItem } from './components/misc';
import { Page } from './components/Page';
import { CustomerAddress } from './components/QuoteDetails/CustomerAddress';
import { CustomerContact } from './components/QuoteDetails/CustomerContact';
import { QuoteDetails } from './components/QuoteDetails/QuoteDetails';
import { QuoteInformation } from './components/QuoteDetails/QuoteInformation';
import { QuoteId } from './components/QuoteId';
import { QuoteLineForPart, QuoteLineForServices } from './components/QuoteLine';
import { PartId } from './components/QuoteLine/PartId';
import { PartSpecs } from './components/QuoteLine/PartSpecs';
import { SiteInformation } from './components/SiteInformation';
import { Specs } from './components/Specs';
import { styles } from './components/styles';

const MWS_SITE_INFORMATION = [
  '500 East Ottawa Street',
  'Logansport, IN 46947-7008',
  'Phone (574) 722 - 8200',
];

export function MWSQuoteDocument() {
  const { quoteLines } = usePDFContext();

  return (
    <Page>
      <Header>
        <Logo
          source={logo}
          text="ISO/TS 16949:2009 Registered"
          extraStyles={[{ height: '28px' }]}
        />

        <SiteInformation
          name="Matthew Warren Spring - A MW Components Company"
          items={MWS_SITE_INFORMATION}
        />

        {/* Some sites may have a different ecommerce site */}
        <QuoteId ecommerceUri={EnvConfig.getKey('MW_COMPONENTS_URI')} />
      </Header>

      <QuoteDetails>
        <CustomerAddress />

        <CustomerContact />

        <QuoteInformation showFOB />
      </QuoteDetails>

      {quoteLines.map((line) => {
        const { part, ...lineProps } = line;
        if (!part) {
          return <QuoteLineForServices {...line} showDescription />;
        }
        return (
          <QuoteLineForPart
            key={line.id}
            {...lineProps}
            part={part}
            showDrawing
          >
            <PartId part={part} showCustomerPartId />

            <PartSpecs specs={line.specs} />
          </QuoteLineForPart>
        );
      })}

      <Specs />

      <EmployeeInformation />

      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={styles.bold}>Additional Terms & Conditions</Text>
          <Text>{'\n'}</Text>
          <List>
            <ListItem>
              <Text style={styles.bold}>PPAP Charges (if required): </Text>{' '}
              $750.00. Additional certifications will be quoted upon request.
            </ListItem>
            <ListItem>
              <Text style={styles.bold}>Tolerances: </Text> Block tolerances do{' '}
              <Text style={styles.bold}>not</Text>
              apply to items quoted unless otherwise specified.
            </ListItem>
            <ListItem>
              <Text style={styles.bold}>Material & Cost Adjustments: </Text> We
              reserve the right to pass through increases in raw material,
              energy, freight, and/or outside processing costs in effect at the
              time of manufacture on both existing and new orders.
            </ListItem>
            <ListItem>
              <Text style={styles.bold}> Delivery:</Text> Quoted lead-time is
              subject to change based on material availability at the time of
              order placement.
            </ListItem>
            <ListItem>
              <Text style={styles.bold}> DFARS / Specialty Material:</Text>{' '}
              DFAR-compliant items are subject to material availability at time
              of order.
            </ListItem>
            <ListItem>
              <Text style={styles.bold}> First-Time Production:</Text> Parts not
              previously manufactured by our facility will undergo a quality
              assurance review prior to the start of production to ensure
              manufacturability and compliance.
            </ListItem>
            <ListItem>
              Commercial tolerances per DIN 2089 will apply if not otherwise
              referenced on the drawing. Items ordered as part of a blanket or
              multiple release agreement must be taken with 12 months
              manufacture.
            </ListItem>
          </List>
        </View>
      </View>
    </Page>
  );
}
